import { todayISO } from "./repeatWorkout";

/**
 * Build `performedAt` for a completed workout form.
 * - If live timer finished → use that timestamp (real clock time).
 * - If the selected day is today → use "now" (actual save/log time).
 * - Otherwise → local noon on that day (stable calendar day without fake "now").
 */
export function resolvePerformedAt(opts: {
  date: string;
  finishedAt?: string | null;
  startedAt?: string | null;
  now?: Date;
}): string {
  const now = opts.now ?? new Date();

  if (opts.finishedAt) {
    const fin = new Date(opts.finishedAt);
    if (!Number.isNaN(fin.getTime())) return fin.toISOString();
  }

  if (opts.date === todayISO(now)) {
    return now.toISOString();
  }

  // Past / future day: keep the calendar date, local noon
  const parts = opts.date.split("-").map(Number);
  if (parts.length === 3 && parts.every((n) => Number.isFinite(n))) {
    const [y, m, d] = parts;
    return new Date(y, m - 1, d, 12, 0, 0, 0).toISOString();
  }

  return now.toISOString();
}

/** Best timestamp to show in lists/details for a completed workout. */
export function displayPerformedAt(w: {
  performedAt: string;
  finishedAt?: string | null;
  startedAt?: string | null;
}): string {
  if (w.finishedAt) {
    const d = new Date(w.finishedAt);
    if (!Number.isNaN(d.getTime())) return w.finishedAt;
  }
  if (w.startedAt) {
    const d = new Date(w.startedAt);
    if (!Number.isNaN(d.getTime())) return w.startedAt;
  }
  return w.performedAt;
}
